import { Component } from '@angular/core';
import { UserService } from '../../shared/services/user.service';
import { Router } from '@angular/router';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { ModalService } from 'src/app/shared/services/modal.service';
import { CompanyGroupDetailsComponent } from '../company-group-details/company-group-details.component';
import { TableColumn } from 'src/app/shared/components/table/table-column.interface';
import { TableSearchRequest } from 'src/app/shared/components/table/table.component';

@Component({
  selector: 'app-company-group-list',
  templateUrl: './company-group-list.component.html',
  styleUrls: ['./company-group-list.component.scss']
})
export class CompanyGroupListComponent {

  companyGroups: any[] = [];
  resultsLength: number = 0;
  isLoading: boolean = false;
  faPlus = faPlus;

  columns: TableColumn[] = [
    { key: 'name',               label: 'Name',                sortable: true, filterable: true },
    { key: 'adminEmailAddress',  label: 'Admin Email Address', sortable: true, filterable: true },
    { key: 'information',        label: 'Additional Information', sortable: true, filterable: true },
    { key: 'active', label: 'Is Active', sortable: true, filterable: true, filterType: 'select',
        filterOptions: [
          { label: 'Yes', value: '{{bool}}true' },
          { label: 'No',  value: '{{bool}}false' }
        ]
      }
  ];

  constructor(
    private userService: UserService,
    public router: Router,
    public modalService: ModalService) {
  }

  onSearch(request: TableSearchRequest) {
    this.isLoading = true;
    this.userService.companyGroupsPaged(request).subscribe({
      next: data => {
        this.companyGroups = data.items;
        this.resultsLength = data.recordCount;
        this.isLoading = false;
      },
      error: () => this.isLoading = false
    });
  }

  addCompanyGroup() {
    const modalRef = this.modalService.openWithOptions(CompanyGroupDetailsComponent, { size: 'lg' });
    modalRef.result.then(
      (result) => { if (result) this.reload(); },
      () => {}
    );
  }

  editCompanyGroup(companyGroup: any) {
    this.router.navigate(['/companygroup', companyGroup.id]);
  }

  private reload() {
    this.onSearch({ page: 1, pageSize: 20, orderBy: 'name', orderDirection: 'asc', filterColumns: [], filterStrings: [], dateRangeFilters: [] });
  }
}